export default __webpack_public_path__ + "media/mock/src/img/logo_jcb-1b0fabe972d97dcc0736649aefd427b8.png";